import { render } from "./create_module.vue?vue&type=template&id=569127ff&scoped=true"
import script from "./create_module.vue?vue&type=script&lang=js"
export * from "./create_module.vue?vue&type=script&lang=js"

import "./create_module.vue?vue&type=style&index=0&id=569127ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569127ff"]])

export default __exports__